import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { ShowDateTime } from "../../../common/controls";
import { ShowReference } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type SatelliteTaskViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  taskTypeValue?: { displayId: string; id: string } | null;
  taskType: string;
  statusValue?: { displayId: string; id: string } | null;
  status: string;
  priorityValue?: { displayId: string; id: string } | null;
  priority: number;
  inputValue?: { displayId: string; id: string } | null;
  input: string;
  outputValue?: { displayId: string; id: string } | null;
  output: string;
  errorValue?: { displayId: string; id: string } | null;
  error: string;
  correlationIdValue?: { displayId: string; id: string } | null;
  correlationId: string;
  timeoutMsValue?: { displayId: string; id: string } | null;
  timeoutMs: number;
  retryCountValue?: { displayId: string; id: string } | null;
  retryCount: number;
  maxRetriesValue?: { displayId: string; id: string } | null;
  maxRetries: number;
  queuedAtValue?: { displayId: string; id: string } | null;
  queuedAt: Date | null;
  sentAtValue?: { displayId: string; id: string } | null;
  sentAt: Date | null;
  startedAtValue?: { displayId: string; id: string } | null;
  startedAt: Date | null;
  completedAtValue?: { displayId: string; id: string } | null;
  completedAt: Date | null;
  durationValue?: { displayId: string; id: string } | null;
  duration: number | undefined;
  botRunValue: { displayId: string; id: string } | null;
};

export const SatelliteTaskViewForm: React.FC<SatelliteTaskViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      taskType = "",
      status = "",
      priority = 0,
      input = "{}",
      output = "{}",
      error = "{}",
      correlationId = "",
      timeoutMs = 0,
      retryCount = 0,
      maxRetries = 0,
      queuedAt = null,
      sentAt = null,
      startedAt = null,
      completedAt = null,
      duration = 0,
      botRunValue,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupSatelliteTaskLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={taskType}
                  label={langStore.SatelliteTaskTaskTypeLabel}
                />
                <ShowMultiLine
                  value={status}
                  label={langStore.SatelliteTaskStatusLabel}
                />
                <ShowNumber
                  value={priority}
                  label={langStore.SatelliteTaskPriorityLabel}
                />
                <InputCodeEditor
                  value={input}
                  onChange={() => {}}
                  label={langStore.SatelliteTaskInputLabel}
                  language="json"
                  readOnly={true}
                />
                <InputCodeEditor
                  value={output}
                  onChange={() => {}}
                  label={langStore.SatelliteTaskOutputLabel}
                  language="json"
                  readOnly={true}
                />
                <InputCodeEditor
                  value={error}
                  onChange={() => {}}
                  label={langStore.SatelliteTaskErrorLabel}
                  language="json"
                  readOnly={true}
                />
                <ShowMultiLine
                  value={correlationId}
                  label={langStore.SatelliteTaskCorrelationIdLabel}
                />
                <ShowNumber
                  value={timeoutMs}
                  label={langStore.SatelliteTaskTimeoutMsLabel}
                />
                <ShowNumber
                  value={retryCount}
                  label={langStore.SatelliteTaskRetryCountLabel}
                />
                <ShowNumber
                  value={maxRetries}
                  label={langStore.SatelliteTaskMaxRetriesLabel}
                />
                <ShowDateTime
                  value={queuedAt}
                  label={langStore.SatelliteTaskQueuedAtLabel}
                />
                <ShowDateTime
                  value={sentAt}
                  label={langStore.SatelliteTaskSentAtLabel}
                />
                <ShowDateTime
                  value={startedAt}
                  label={langStore.SatelliteTaskStartedAtLabel}
                />
                <ShowDateTime
                  value={completedAt}
                  label={langStore.SatelliteTaskCompletedAtLabel}
                />
                <ShowNumber
                  value={duration}
                  label={langStore.SatelliteTaskDurationLabel}
                />
                <ShowReference
                  label={langStore.SatelliteTaskBotRunLabel}
                  selectedValue={langStore.displayIdByLang(
                    botRunValue?.displayId
                  )}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
